<template>
  <div class="svg-container">
    <svg class="delete-svg" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" xml:space="preserve" viewBox="0 0 85 85" width="30px">
      <path fill="currentColor" d="M63.6,69.2c-0.1,1.6-1.4,2.8-3,2.8H26c-1.6,0-2.9-1.3-3-2.8l-1.7-37.8c-0.1-1.6,1.2-2.8,2.7-2.8h38.4
        c1.6,0,2.8,1.3,2.7,2.8L63.6,69.2z M70.5,20.1c0-2-1.6-3.6-3.6-3.6H54.5l-1.9-3.8H34l-2,3.8H19.5c-2,0-3.6,1.6-3.6,3.6
        c0,2,1.6,3.6,3.6,3.6h47.3C68.8,23.8,70.5,22.2,70.5,20.1z"/>
    </svg>
  </div>
</template>
